import {currencyFormatter} from 'utils/formatter'
import ShiftDetailRow from '../ShiftDetailRow'

class ShiftDetailTotal extends React.Component {
  render () {
    let {shift} = this.props
    return (<div className='row'>
      <div className='col-lg-12'>
        <div className='form-group col-sm-12 label-section'>
          <label>Total</label>
        </div>
        <div className='col-sm-12 total_detail no-padding-right'>
          <ShiftDetailRow label='Total Expected' value={currencyFormatter(shift.total_expected)} />
          <ShiftDetailRow label='Total Actual' value={shift.ended_at ? currencyFormatter(shift.total_actual) : '-'} />
          <div className='row'>
            <div className='col-sm-12'>
              <div className='form-group col-sm-12 label-section end_detail'>
                <label>Difference</label>
                <div className='pull-right'>{shift.ended_at ? currencyFormatter(shift.total_difference) : '-'}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>)
  }
}
ShiftDetailTotal.propTypes = {
  shift: React.PropTypes.object
}
export default ShiftDetailTotal



// WEBPACK FOOTER //
// ./app/pages/Reports/Shift/ShiftDetail/ShiftDetailTotal/ShiftDetailTotal.js